



































































import { Component } from "vue-property-decorator";
import WidgetBase from "../WidgetBase";
import ImageUploadComponent from "../../../components/ImageUploadComponent/index.vue";
import MagicValidator from "../../../magic/MagicValidator.vue";

@Component({
  name: "ImageAttachmentWidget",
  components: { ImageUploadComponent, MagicValidator }
})
export default class ImageAttachmentWidget extends WidgetBase implements App.PuttedWidgetComponent {
  setValue(value: string) {
    console.log(value);
  }
}
